import { useMapExperiment as BaseUseMapExperiment } from '@eventbrite/search-utils';
import { useEnvContext } from '../../context';

export const useMapExperiment = () => {
    const envContext = useEnvContext();
    const isMobile = envContext?.env?.isMobile;
    return BaseUseMapExperiment(!!isMobile);
};
